import Chip from "@mui/material/Chip";
import { Schedule } from "./enums";

export default function ScheduleChip(props) {
	let { schedule } = props;
	if (!schedule) {
		return;
	}

	let size = props?.size;
	let variant = 'outlined';

	let scheduleDefinition = Schedule[schedule];
	if (!scheduleDefinition) {
		scheduleDefinition = { label: schedule };
	}

	return (
		// <Chip label={scheduleDefinition?.label} size={size} variant={variant} color={scheduleDefinition?.colour} />
		<Chip label={scheduleDefinition?.label} size={size} variant={variant} style={{color: scheduleDefinition?.colour, borderColor: scheduleDefinition?.colour, backgroundColor: scheduleDefinition?.bgColour}} />
	);
}
